import React, { useRef, useState } from 'react';

import { DISABLE_SWIPE } from '../utilities/enums';
import {
  PRE_FLIGHT_BRIEFING_EMPTY,
  sanitizeBriefingHtml,
  useOverflowObserver,
} from '../helpers';

export const BriefingTopics = ({ topic }) => {
  const containerRef = useRef(null);
  const contentRef = useRef(null);
  const [isSwipeDisabled, setIsSwipeDisabled] = useState(false);

  useOverflowObserver(containerRef, contentRef, setIsSwipeDisabled);

  const html = sanitizeBriefingHtml(topic?.html);

  return (
    <div
      ref={containerRef}
      className={`crew-msg-container ${isSwipeDisabled ? DISABLE_SWIPE : ''}`}
    >
      <div ref={contentRef} className="briefing-topics-body">
        {html ? (
          <div dangerouslySetInnerHTML={{ __html: html }} />
        ) : (
          <p>{PRE_FLIGHT_BRIEFING_EMPTY}</p>
        )}
      </div>
    </div>
  );
};
